import * as R from 'ramda';
import {routes as baseRoutes} from '@practicegenius/register-account/src/routes';

/** routes for registration without the basename */
export const routes = baseRoutes;
export const basename = '/account/register';

/** routes for registration with the basename */
export const registrationRoutes = R.mapObjIndexed(
  (route: string) => `${basename}${route}`,
  routes,
);
